<zxing-scanner
  class="scanner"
  #scanner
  [formats]="allowedFormats"
  [autostart]="true"
  (scanSuccess)="scanSuccessHandler($event)"
  (scanComplete)="scanCompleteHandler($event)">
</zxing-scanner>
